import React from 'react';

const majutus = {
  "majutus.yld.pealkiri": "Accomodation",
  "majutus.yld.blokk1": () => (
    <>
      <h2 className="title is-2">Accommodation in Varbla Holiday village</h2>
      <p>
        Cozy and homey rooms for everybody. Apartment-style rooms through 2
        floors and loghouses with a beautiful view.
      </p>
      <p>
        In the summer we can provide accommodation for 142 guests and in the
        winter for 84 guests.
      </p>
    </>
  ),
  "majutus.motell.pealkiri": "Motel",
  "majutus.motell.kaart.kirjeldus":
    "Our cozy and modern motel offers you 1-,2-,3-,4- and 5 person rooms.",
  "majutus.motell.hinnakiri": () => (
    <>
      <h5 className="title is-5">Mon, Tue, Wed, Thu (price for 1 night) </h5>
      <p>Regular room for one 45€</p>
      <p>Regular suite for two 100€</p>
      <p>Suite with sauna for two 110€</p>
      <p>Suite with bath for two 110€</p>
      <br />
      <h5 className="title is-5">Fri, Sat, Sun (price for 1 night) </h5>
      <p>Regular room for one 55€</p>
      <p>Regular suite for two 110€</p>
      <p>Suite with sauna for two 130€</p>
      <p>Suite with bath for two 130€</p>
      <br />
      <p>Breakfast is included!</p>
    </>
  ),
  "majutus.motell.blokk1": () => (
    <>
      <p>
        Our cozy and modern motel offers you 1-,2-,3-,4- and 5 person rooms,
        where everyone of them has it´s own bathroom.
      </p>
      <p>We have 20 rooms, which can accommodate 54 guests.</p>
      <p>
        Rooms with a sea view have balconies, where you can enjoy beautiful
        sunsets.
      </p>
      <p>
        Bar is on the first floor, where you can watch TV, read a newspaper or
        play billiards.
      </p>
      <p>
        If you would like to have dinner in our Motel, please let us know in
        advance.
      </p>
    </>
  ),
  "majutus.ridaelamud.pealkiri": "Terraced houses",
  "majutus.ridaelamud.kaart.kirjeldus":
    "We have 4 apartment-style rooms, which are perfect for big familys.",
  "majutus.ridaelamud.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        Mon, Tue, Wed, Thu 1 terraced house for 8 people: 140€
      </h5>
      <h5 className="title is-5">
        Fri, Sat, Sun 1 terraced house for 8 people: 160€
      </h5>
    </>
  ),
  "majutus.ridaelamud.blokk1": () => (
    <>
      <p>We have 4 apartment-style rooms, which are perfect for big familys.</p>
      <p>
        These are two-storey apartments, where on the first floor, there's a
        living room, bathroom and a bedroom with 3 small beds. On the second
        floor, there's another bathroom and 2 bedrooms with on 1 big bed and 3
        small beds
      </p>
      <ul>
        <li>3 bedrooms for 8 guests</li>
        <li>2 bathrooms</li>
        <li>living room with a couch and a TV</li>
        <li>Small kitchen ( everything you need is included)</li>
        <li>Bed sheets, towels, soap</li>
        <li>Terrace with a bench</li>
      </ul>
    </>
  ),
  "majutus.saunamajad.pealkiri": "Sauna houses",
  "majutus.saunamajad.kaart.kirjeldus": "We have 2 saunas available for rent.",
  "majutus.saunamajad.motellisaun.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        Sauna usage 20€/h+ 1.50€ for every sauna user
      </h5>
      <h5 className="title is-5">
        Accomodation for one night 25€ per person (breakfast included)
      </h5>
      <h5 className="title is-5">
        Whole sauna house for one night 225€ (includes unlimited sauna usage)
      </h5>
    </>
  ),
  "majutus.saunamajad.motellisaun.blokk1": () => (
    <>
      <h2 className="title is-2">Motel sauna</h2>
      <p>
        Next to the Motel, there's a little sauna, what you can rent for just to
        go to the sauna or a little sauna party with your friends.
      </p>
      <p>
        On the first floor, there's a homey fireplace room, showers, sauna and a
        bathroom. Theres also 6 beds for 12 guests on the second floor.
      </p>
      <p>The sauna itself can fit 5 persons at a time.</p>
      <p>
        Right next to the sauna, there's a barrel sauna aswell, what you could
        rent for your stay in the sauna.
      </p>
      <ul>
        <li>6 big beds</li>
        <li>fireplace room</li>
        <li>bathroom</li>
        <li>sauna</li>
        <li>toilet</li>
        <li>terrace</li>
        <li>refridgerator</li>
        <li>barrel sauna</li>
      </ul>
    </>
  ),
  "majutus.saunamajad.juuliaadu.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        Mon, Tue, Wed, Thu whole house rent for one night 300€
      </h5>
      <h5 className="title is-5">
        Fri, Sat, Sun, Thu whole house rent for one night 350€
      </h5>
      <p>(Period 1. june- 31. september)</p>
      <p>During Midsummer 22.-25.06 350€ for one night</p>
    </>
  ),
  "majutus.saunamajad.juuliaadu.blokk1": () => (
    <>
      <h2 className="title is-2">Juuli & Aadu Sauna</h2>
      <p>
        Perfect place to rest with your friends or family just 100 meters from
        the sand beach.
      </p>
      <p>
        Sauna house has a little kitchen, big living room and a sauna that fits
        10 guest at a time. In front of the house, there's a big terrace and a
        barrel sauna, where you can relax and enjoy your beautiful beach view.
      </p>
      <p>
        The second floor is mostly bedrooms and a bathroom aswell. 4 bedrooms
        with 2 big beds and 6 small beds.
      </p>
      <ul>
        <li>10 sleeping spots</li>
        <li>living room</li>
        <li>kitchen with everything you need to cook a small dinner.</li>
        <li>sauna</li>
        <li>toilets on both floors</li>
        <li>Bathroom on the first floor</li>
        <li>Sand beach just 100 meters away from the sauna</li>
        <li>Terrace with a barrel sauna</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.pealkiri": "Loghouses",
  "majutus.palkmajad.kaart.kirjeldus":
    "Perfect place to come and spend your holiday with your friends and family.",
  "majutus.palkmajad.sissejuhatus": () => (
    <>
      <p>
        Perfect place to come and spend your holiday with your friends and
        family.
      </p>
      <p>
        You can play some Beach volleyball, grill some food or take a romantic
        walk on the pier.
      </p>
      <p>
        Three very homey guesthouses awaits you, where everything essential is
        available to enjoy your vacation.
      </p>
    </>
  ),
  "majutus.palkmajad.taretareke.blokk1": () => (
    <>
      <h2 className="title is-2">Tare-Tareke</h2>
      <p>
        Small and cozy house with a small living room, bathroom and two
        bedrooms, both for 3 guest each.
      </p>
      <p>Small sleeping-area is just under the roof aswell for 6 guests.</p>
      <ul>
        <li>for 12 guests</li>
        <li>bathroom</li>
        <li>living room</li>
        <li>refrigerator and a stove</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.taretareke.hinnakiri": () => (
    <>
      <p style={{ color: "red" }}>This house is reserved from 01.06 to 30.08</p>
      <br />
      <h5 className="title is-5">
        Mon, Tue, Wed, Thu whole house rent for one night 150€
      </h5>
      <h5 className="title is-5">
        Fri, Sat, Sun, Thu whole house rent for one night 175€
      </h5>
      <p>(Period 1. june- 31. september)</p>
      <p>During Midsummer 22.-25.06 175€ for one night</p>
    </>
  ),
  "majutus.palkmajad.rannumehe.blokk1": () => (
    <>
      <h2 className="title is-2">Rännumehemaja (Travellers house)</h2>
      <p>Rännumehemaja can host 7 travelers at a time.</p>
      <p>There's 3 bedrooms, 2 bathrooms and a kitchen.</p>
      <p>
        Every bedroom has it's own name, which comes from different Estonian
        travelers, some are made-up, some are real.
      </p>
      <ul>
        <li>3 bedrooms</li>
        <li>for 7 guests</li>
        <li>2 bathrooms</li>
        <li>living room</li>
        <li>kitchen</li>
        <li>coffee machine, stove, refrigerator</li>
        <li>fireplace</li>
        <li>terrace</li>
        <li>sandbeach just 100m from the guesthouse</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.rannumehe.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        Mon, Tue, Wed, Thu whole house rent for one night 200€
      </h5>
      <h5 className="title is-5">
        Fri, Sat, Sun, Thu whole house rent for one night 220€
      </h5>
      <p>(Period 1. june- 31. september)</p>
      <p>During Midsummer 22.-25.06 220€ for one night</p>
    </>
  ),
  "majutus.palkmajad.pakapiku.blokk1": () => (
    <>
      <h2 className="title is-2">Päkapikumaja (Elf's house)</h2>
      <p>
        This cozy house looks small from the outside, but from the inside, it's
        not that small.
      </p>
      <p>House comes with a beautiful view to the sea.</p>
      <p>
        Three bedrooms, one downstairs and two upstairs. There's little living
        room and kitchen space.
      </p>
      <ul>
        <li>3 bedrooms</li>
        <li>11 guest ( 3 small beds and 4 big beds)</li>
        <li>living room</li>
        <li>kitchen</li>
        <li>bathroom</li>
        <li>toilet</li>
        <li>barbeque area</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.pakapiku.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        Mon, Tue, Wed, Thu whole house rent for one night 200€
      </h5>
      <h5 className="title is-5">
        Fri, Sat, Sun, Thu whole house rent for one night 220€
      </h5>
      <p>(Period 1. june- 31. september)</p>
      <p>During Midsummer 22.-25.06 220 for one night</p>
    </>
  ),
  "majutus.kampingud.pealkiri": "Camphouses",
  "majutus.kampingud.kaart.kirjeldus":
    "In the summer, we offer small camphouses",
  "majutus.kampingud.blokk1": () => (
    <>
      <h2 className="title is-2">Camphouses</h2>
      <p>
        In the summer, we offer small campings aswell, which contains 2 beds
        with bedsheets and a towel.
      </p>
      <p>There's a bathroom option aswell.</p>
      <p>Price for 1 person is 15€.</p>
    </>
  ),
};

export default majutus;
